/*
 * @Author: 刘欢
 * @LastEditors: 刘欢
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-03-12 20:11:57
 * @Description: 新增或编辑品牌档案
 */

import type { IBrandModel, IBrandStore } from '@monorepo/types/document/brand/brand.types';
import { tableUpdate } from '@monorepo/utils';

const initState: IBrandStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
  },
  keyword: '',
};

const ProductBrandStore: IBrandModel = {
  namespace: 'productBrandStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default ProductBrandStore;
